<script setup lang="ts">
type MobileNavItem = {
  href: string
  text: string
}

defineProps<{
  items?: MobileNavItem[]
}>()
</script>

<template>
  <v-menu-base class="public-mobile-nav" no-mobile-modal card-class="public-mobile-nav__card">
    <template #activator="{ onclick, isOpen }">
      <v-button mode="outlined" class="public-mobile-nav__button" @click="onclick">
        <div class="hamburger" :class="{ 'is-open': isOpen }">
          <span class="hamburger__line"></span>
          <span class="hamburger__line"></span>
          <span class="hamburger__line"></span>
        </div>
      </v-button>
    </template>

    <ul class="pa-1 public-mobile-nav__items">
      <v-menu-button v-for="(item, i) in items" :key="i" :href="item.href" target="_blank" has-arrow>
        {{ item.text }}
      </v-menu-button>
    </ul>
  </v-menu-base>
</template>

<style lang="scss">
.public-mobile-nav {
  &__button {
    padding: 4px 8px;
    border-color: rgba(black, 0.4) !important;
  }

  &__items {
    min-width: 300px;
  }
}

.public-mobile-nav__card {
  box-shadow:
    -1px 1px 4px rgba(58, 70, 93, 0.22),
    -4px 5px 18px 0px rgba(29, 42, 68, 0.23);
}

.hamburger {
  width: 20px;
  height: 12px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  &__line {
    width: 100%;
    height: 2px;
    background: currentColor;
    transition: transform 0.2s ease;
  }

  &.is-open {
    .hamburger__line {
      &:first-child {
        transform: translateY(5px) rotate(45deg);
      }
      &:nth-child(2) {
        opacity: 0;
      }
      &:last-child {
        transform: translateY(-5px) rotate(-45deg);
      }
    }
  }
}
</style>
